import React, { Component } from "react";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { DataTable } from "primereact/datatable";
import { CSVLink, CSVDownload } from "react-csv";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import tableRequest from "../../models/tableRequest";
import DemappingReportService from "../../services/DemappingReportService.js";
// import MessageComponent from '../../template/Message';
import $ from "jquery";
import { BreadCrumb } from "primereact/breadcrumb";
import { Card } from "primereact/card";
import { toast, ToastContainer } from "react-toastify";
import { Dropdown } from "primereact/dropdown";

export default class DamageReport extends Component {
  constructor(props) {
    super(props);
    this.surveyLink = React.createRef();

    this.DemappingReportService = new DemappingReportService();
    this.tblResponse = new tableRequest();
    this.state = {
      FromDate: new Date(),
      ToDate: new Date(),
      sales: [],
      loading: true,
      first: 0,
      rows: 10,
      totalRecords: 0,
      emptyMessage: "No Data found",

      // DAMAGE DATE SORT
      sortField: "DamageDate",
      sortOrder: -1, // DESC
      allData: [],
      BatchCode: "",
      batchCodeOptions: [],
    };



    this.onPage = this.onPage.bind(this);
    this.FilterData = this.FilterData.bind(this);
    this.searchFilter = this.searchFilter.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.GetDamageExport = this.GetDamageExport.bind(this);
    this.GetDamageData = this.GetDamageData.bind(this);
    this.onSort = this.onSort.bind(this);
    //this.setPreprintedValue = this.setPreprintedValue.bind(this);
  }

   GetBatchCodeList() {
  this.DemappingReportService.GetBatchCodeList()
    .then((res) => {
      const responseData = res.data;

      if (responseData?.ResponseData?.length > 0) {
        
        const options = responseData.ResponseData.map((item) => ({
        value: item.BatchCode.trim(),   // ✅ trim
        label: item.BatchCode.trim(),   // ✅ trim
    }));


        this.setState({ batchCodeOptions: options });
      }
    })
    .catch(() => {
      toast.error("Failed to load batch codes");
    });
}


  //to trigger api function on page call

  componentDidMount() {
    setTimeout(() => {
      var date = new Date();
      date.setDate(date.getDate() - 7);
      this.tblResponse.FromDate = this.toMMDDYYYY(date);
      this.tblResponse.ToDate = this.toMMDDYYYY(new Date());
      this.setState({
        FromDate: date,
        ToDate: new Date(),
      });
      
      this.GetDamageData();

      //this.GetDemappingExport();
    }, 1000);
    $(".p-column-title").on("click", function () {
      $(this)
        .next()
        .removeClass("pi-sort")
        .toggleClass("pi-sort-up")
        .addClass("pi-sort-down");
    });
  }

  toMMDDYYYY(date) {
    const d = new Date(date);
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    const yyyy = d.getFullYear();
    return `${mm}/${dd}/${yyyy}`;
  }

  //to search
  searchFilter(e) {
    this.setState({
      loading: true,
    });
    this.tblResponse.SearchValue = e.target.value;
    this.GetDamageData();
  }

  onChange = (date) => this.setState({ FromDate: "", ToDate: "" });
  //on page loading
  onPage(event) {
    this.setState({
      loading: true,
    });

    //imitate delay of a backend call
    setTimeout(() => {
      this.getLazyLoadingValues(event);
      this.GetDamageData();
    }, 250);
  }

  // get data list from api
  GetDamageExport() {
    this.DemappingReportService.GetDamageReport(this.tblResponse).then(
      (data) => {
        const resdata = data.data;
        //if response data not null
        if (
          resdata !== null &&
          resdata.ResponseData !== null &&
          resdata.ResponseData.length > 0
        ) {
          resdata.ResponseData.forEach(function (v) {
            delete v.TotalRows;
            delete v.IsDemapped;
            delete v.ProductImg;
            delete v.Weight;
            delete v.Dimensions;
           // delete v.BatchCode;
            delete v.fakeVerify;
            delete v.SupplierCode;
            delete v.FromDate;
            delete v.ToDate;
          });
          this.setState({
            allData: resdata.ResponseData,
          });
          this.setState({ allData: resdata.ResponseData }, () => {
            this.surveyLink.link.click();
          });

          // if (resdata.ResponseData !== null) {

          // }
        }
      }
    );
  }
  //to handle
  //resolved KREP-22
    handleChange(event) {
    const { name, value } = event.target;

    if (name === "BatchCode") {
      this.setState({ BatchCode: value });
      return;
    }

    //to validate each form field with required conditions
    switch (name) {
      case "FromDate":
        if (value == null || !(value instanceof Date)) {
          this.formIsValid = false;
          toast.error("Please select from date.");
          return;
        } else if (
          !value.toLocaleDateString().match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/)
        ) {
          this.formIsValid = false;
          toast.error("Please enter only date.");
          return;
        } else if (value instanceof Date && this.state.ToDate instanceof Date) {
          const startDate = value;
          const endDate = this.state.ToDate;
          if (!(Date.parse(startDate) <= Date.parse(endDate))) {
            this.formIsValid = false;
            toast.error("From date must be less than to date.");
            return;
          }
        }

        break;
      case "ToDate":
        if (value == null || !(value instanceof Date)) {
          this.formIsValid = false;
          toast.error("Please select to date.");
          return;
        } else if (
          !value.toLocaleDateString().match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/)
        ) {
          this.formIsValid = false;
          toast.error("Please enter only date.");
          return;
        } else if (
          value instanceof Date &&
          this.state.FromDate instanceof Date
        ) {
          const startDate = this.state.FromDate;
          const endDate = value;
          if (!(Date.parse(startDate) <= Date.parse(endDate))) {
            this.formIsValid = false;
            toast.error("To date must be greater than from date.");
            return;
          }
        }

        break;
      default:
        break;
    }
    this.setState({ [name]: value });
  }
  //to filter data
FilterData() {
  this.tblResponse.FromDate = this.toMMDDYYYY(this.state.FromDate);
  this.tblResponse.ToDate = this.toMMDDYYYY(this.state.ToDate);
  this.tblResponse.BatchCode = this.state.BatchCode || null;
  this.tblResponse.First = 1;
  this.tblResponse.PageSize = this.state.rows;
  this.tblResponse.SortColumn = this.state.sortField || "DamageDate";
  this.tblResponse.SortOrder = this.state.sortOrder === 1 ? "ASC" : "DESC";
  this.setState({ first: 0 }, this.GetDamageData);

}

getLazyLoadingValues(event) {
  this.setState({ rows: event.rows });
  this.tblResponse.PageSize = event.rows;
  this.tblResponse.First = event.first + 1;
  this.tblResponse.IsActive = "1";
  this.tblResponse.SearchValue = event.globalFilter ? event.globalFilter : "";
  this.tblResponse.SortOrder = event.sortOrder === 1 ? "ASC" : "DESC";
  this.tblResponse.SortColumn = event.sortField || this.state.sortField;
}


  // get data list from api
GetDamageData() {

  this.tblResponse.SortColumn = this.state.sortField || "DamageDate";
  this.tblResponse.SortOrder = this.state.sortOrder === 1 ? "ASC" : "DESC";

  this.DemappingReportService
    .GetDamageReport(this.tblResponse)
    .then((data) => {
      const resdata = data.data;

      if (resdata?.ResponseData?.length > 0) {
        const formattedData = resdata.ResponseData.map((item) => {
          if (item.DamageDate) {
            const date = new Date(item.DamageDate);
            const dd = String(date.getDate()).padStart(2, "0");
            const mm = String(date.getMonth() + 1).padStart(2, "0");
            const yyyy = date.getFullYear();
            const hh = String(date.getHours()).padStart(2, "0");
            const min = String(date.getMinutes()).padStart(2, "0");
            item.DamageDate = `${dd}-${mm}-${yyyy} ${hh}:${min}`;
          }
          return item;
        });

        this.datasource = formattedData;

        const uniqueBatchCodes = [
          ...new Set(
            formattedData
              .map((item) => item.BatchCode)
              .filter((code) => code && String(code).trim() !== "")
              .map((code) => String(code).trim()),
          ),
        ];

        const batchOptions = uniqueBatchCodes.map((code) => ({
          value: code,
          label: code,
        }));

        const selectedBatch = this.state.BatchCode;
        const selectedExists = batchOptions.some(
          (x) => x.value === selectedBatch,
        );

        this.setState({
          totalRecords: formattedData[0].TotalRows,
          first: this.tblResponse.First - 1,
          sales: this.datasource.slice(
            0,
            this.tblResponse.First - 1 + this.tblResponse.PageSize,
          ),
          batchCodeOptions: batchOptions,
          BatchCode: selectedExists ? selectedBatch : "",
          loading: false,
        });
      } else {
        this.datasource = [];
        this.setState({
          totalRecords: 0,
          first: 1,
          sales: [],
          batchCodeOptions: [],
          BatchCode: "",
          loading: false,
        });
      }
    })
    .catch(() => {
      this.datasource = [];
      this.setState({
        totalRecords: 0,
        first: 1,
        sales: [],
        batchCodeOptions: [],
        BatchCode: "",
        loading: false,
      });
    });
}

  //to sort
  onSort(event) {
    this.setState({
      sortField: event.sortField,
      sortOrder: event.sortOrder
    });

    this.tblResponse.SortColumn = event.sortField; // NOW SORTS BY DAMAGE DATE
    this.tblResponse.SortOrder = event.sortOrder === 1 ? "ASC" : "DESC";
    this.GetDamageData();
  }


  /// to set isPreprinted
  // setPreprintedValue(e) {

  //     this.setState({
  //         isPreprintedValue: e.value,
  //         isPreprinted: e.value == "Static Qr Demapping" ? false : true
  //     }, () => {
  //         this.tblResponse.isPreprinted = this.state.isPreprinted;
  //         this.GetDemapping();
  //     });

  // }

  //to render html part
  render() {
    const items = [{ label: "Masters" }, { label: "Damage Report" }];
    const home = { icon: "pi pi-home", url: "/dashboard" };
    const options = ["Static Qr Damage"]; //, 'PrePrinted Qr Damage'];
    let header = (
      <div className="row">
        <div className="col-md-8">
          <form className="form-inline">
            <div className="form-group mr-2">
              <Calendar
                value={this.state.FromDate}
                name="FromDate"
                onChange={this.handleChange}
                appendTo={document.getElementById("root")}
                placeholder="From Date"
                dateFormat="mm/dd/yy"
              />
            </div>

            <div className="form-group mr-2">
              <Calendar
                value={this.state.ToDate}
                name="ToDate"
                onChange={this.handleChange}
                appendTo={document.getElementById("root")}
                placeholder="To Date"
                dateFormat="mm/dd/yy"
              />
            </div>

             <div className="form-group mr-2" style={{ minWidth: "200px" }}>
               <Dropdown
                 value={this.state.BatchCode}
                 options={this.state.batchCodeOptions}
                 onChange={(e) =>
                 this.handleChange({
                 target: { name: "BatchCode", value: e.value }
                })
              }
              optionLabel="label"
              optionValue="value"
              placeholder="Search Batch"
              filter
              showClear
              className="w-100"
              style={{ height: "38px" }}
             />
           </div>


            <button
              type="button"
              onClick={this.FilterData}
              className="btn btn-primary ml-3"
            >
              Submit
            </button>
          </form>
        </div>
        <div className="text-right col-md-4">
          <i className="pi pi-search" style={{ margin: "4px 4px 0 0" }}></i>
          <InputText
            type="search"
            onInput={this.searchFilter}
            placeholder="Global Search"
            size="22"
          />
          <button
            className="btn btn-primary ml-2 mb-1 export-disabled"
            target="_blank"
            onClick={this.GetDamageExport}
          >
            Export
          </button>
          <CSVLink
            hidden={true}
            data={this.state.allData}
            ref={(r) => (this.surveyLink = r)}
            filename={"Damage report.csv"}
          >
            Export
          </CSVLink>
        </div>
      </div>
    );
    return (
      <>
        {/* <MessageComponent ref="Messchild" /> */}
        {/* {<Loaders loader={this.state.updateLoader} /> } */}

        <Card className="mt5">
          <div className="row">
            <div className="col-md-6 heading report">
              <h3>Damage Report</h3>
            </div>
            <div className="col-md-6 custom-breadcrumb report">
              <BreadCrumb model={items} home={home} />
            </div>
          </div>
          <DataTable
            exportFilename="Damage Report"
            scrollable
            responsive={true}
            header={header}
            globalFilter={this.state.globalFilter}
            emptyMessage={this.state.emptyMessage}
            value={this.state.sales}
            sortMode="multiple"
            paginator={true}
            rows={this.state.rows}
            rowsPerPageOptions={[10, 50, 200, 500]}
            totalRecords={this.state.totalRecords}
            lazy={true}
            first={this.state.first}
            onPage={this.onPage}
            onSort={this.onSort}
            ref={(el) => {
              this.dt = el;
            }}
          >
            <Column field="SeqNo" header="Seq No" sortable={true} />
            <Column field="ProductCode" header="Product" sortable={true} />
              <Column field="BatchCode" header="Batch Code" sortable={true} />
            <Column field="SupplierCode" header="Supplier" sortable={true} />
            <Column field="BarCode" header="BarCode" sortable={true} />
            <Column field="UniqueCode" header="Unique Code" sortable={true} />
            <Column field="Colour" header="Colour" sortable={true} />
            <Column field="CreatedDate" header="Damage Date" sortable={true} />
          </DataTable>
        </Card>
      </>
    );
  }
}



